import React, { useEffect, useState } from "react";
import { set, useForm } from "react-hook-form";
import { toast } from "react-toastify";
import Head from "../../layout/head/Head";
import Content from "../../layout/content/Content";
import {
    Block,
    BlockBetween,
    BlockHead,
    BlockHeadContent,
    BlockTitle,
    Icon,
    PreviewAltCard,
} from "../../components/Component";
import Status from "../../MyComp/UI/form/Status";
import { Badge, Button, Col, Form, Modal, ModalBody, ModalFooter, ModalHeader, Row } from "reactstrap";
import MyButton from "../../MyComp/UI/form/MyButton";
import MyDataTable from "../../MyComp/UI/DataTable/MyDataTable";
import ConfirmModal from "../../MyComp/UI/modals/ConfirmModal";
import MyInput from "../../MyComp/UI/form/MyInput";
import OrderComponent from "../../MyComp/UI/form/OrderComponent";
import QualificationComponent from "../../MyComp/UI/form/QualificationComponent";
import EmailInput from "../../MyComp/UI/form/EmailInput";
import DateTimePicker from "../../pages/components/forms/DateTimePicker";
import DateComponent from "../../MyComp/UI/form/DateComponent";
import SelectComponent from "../../MyComp/UI/form/SelectComponent";
import TextAreaInput from "../../MyComp/UI/form/TextAreaInput";
import { Navigate } from "react-router";
import MessageProfileSidebar from "../../pages/panel/e-commerce/support/MessageProfile";
import useLogout from "../../hooks/useLogout";
import { BASE_URL_IMG } from "../../assets/constants";
import ViewImage from "../../MyComp/UI/modals/ViewImage";
import MyEmail from "../../MyComp/UI/form/MyEmail";
import MySelect from "../../MyComp/UI/form/MySelect";
import MyDate from "../../MyComp/UI/form/MyDate";
import MyTextArea from "../../MyComp/UI/form/MyTextArea";
import MyMobile from "../../MyComp/UI/form/MyMobile";
import { UserAvatarCell } from "../../MyComp/ImageView/UserAvatarCell";
import ImageUpload from "../../MyComp/UI/form/ImageUpload";
import { getZipDetailsAPI } from "../../api/master/indes";
import { addTeleCallerUserAPI, getTeleCallerUserListAPI, updateTeleCallerUserAPI } from "../../api/TellecallerUser";
import ApiPaginationDataTable from "../../MyComp/UI/DataTable/ApiPaginationDataTable";
import { createPharmacyBoy, pharmacyBoyList, updatePharmacyBoy } from "../../api/pahrmacy";
import { useNavigate } from "react-router-dom";

const User = () => {
    const {
        register,
        itemPerPage,
        handleSubmit,
        setValue,
        watch,
        trigger,
        clearErrors,
        reset,
        setError,
        getValues,
        control,
        formState: { errors },
        resetF
    } = useForm({
        defaultValues: {
            name: "",
            email: "",
            mobile: "",
            full_address: "",
            pin_code: "",
            district: "",
            state: "",
            status: true,
        },
    });

    const { logout } = useLogout();

    // Separate table state from form
    const [tableData, setTableData] = useState([]);
    const [tableLoading, setTableLoading] = useState(false);
    const [formLoading, setFormLoading] = useState(false);
    const [imageOpen, setImageOpen] = useState(false);
    const [isOpen, setIsOpen] = useState(false);
    const [selectedRow, setSelectedRow] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [loading, setLoading] = useState(false);
    const [mode, setMode] = useState("Add");
    const navigate = useNavigate();

    // let labId = location?.state?.labId;

    const columns = [
        {
            name: "Name",
            selector: (row) => row?.name,
            sortable: true,
            wrap: true,
        },
        {
            name: "Email",
            selector: (row) => row?.email,
            sortable: true,
        },
        {
            name: "Phone Number",
            selector: (row) => row?.mobile,
            sortable: true,
        },
        {
            name: "Status",
            selector: (row) => row?.status,
            cell: (row) => (
                <div style={{ cursor: "pointer" }} onClick={() => handleToggleStatus(row)}>
                    <Badge color={row.status ? "success" : "danger"}>
                        {row.status ? "Active" : "Inactive"}
                    </Badge>
                </div>
            ),
            sortable: true,
            width:"150px"
        },
        {
            name: "Action",
            width:"150px",
            cell: (row) => (
                <Button
                    outline
                    color="warning"
                    size="xs"
                    onClick={() => handleEdit(row)}
                >
                    <Icon name="edit" />
                </Button>
            ),
        },
    ];


    const [totalRows, setTotalRows] = useState(0);
    const [perPage, setPerPage] = useState(25);
    const [currentPage, setCurrentPage] = useState(1);
    const [debouncedSearch, setDebouncedSearch] = useState("");



    const handleEdit = (row) => {
        setMode("Edit");
        setIsOpen(true);
        setSelectedRow(row);

        setValue("name", row.name);
        setValue("email", row.email);
        setValue("mobile", row.mobile);

        // FIX STATUS
        setValue("status", {
            label: row.status ? "Active" : "Inactive",
            value: row.status,
        });

        setValue("selectedRow", row);
    };

    const handlePerRowsChange = (newPerPage, page) => {
        const rows = isNaN(newPerPage) ? totalRows : newPerPage;
        setPerPage(rows);
        setValue("page", page);
        console.log("rows", page, rows);
    };
    const handlePageChange = (page) => {
        console.log("page", page);
        setPerPage(perPage);
        setCurrentPage(page);
        setValue("page", page);
    };


    useEffect(() => {
        serverSideSearch();
    }, [perPage, currentPage]);


    const serverSideSearch = () => {
        const body = {
            search: watch("server_search"),
            page: currentPage,
            limit: perPage,
        };

        setLoading(true);

        pharmacyBoyList(body)
            .then((res) => {
                console.log("API Response:", res);
                if (res?.data?.status === true) {

                    const apiData = res?.data?.data;
                    setTableData(apiData?.pharmacyBoyList || []);
                    setTotalRows(apiData?.totalRecords || 0);

                }
                else if (res?.data?.status === "expired") {
                    logout();
                    toast.error(res?.data?.message);
                }
                else {
                    setTableData([]);
                }

                setLoading(false);
            })
            .catch((err) => {
                console.log("API Error:", err);
                setLoading(false);
            });
    };




    useEffect(() => {
        if (watch("server_search")?.length == 0) {
            serverSideSearch();
        }
    }, [watch("server_search")]);



    const handleToggleStatus = (row) => {
        setValue("selectedRow", row);
        setShowModal(true);
    };

    console.log('tableData', tableData)


    const onFormSubmit = async (formData) => {
        try {
            setFormLoading(true);

            const payload = {
                name: formData.name,
                email: formData.email,
                mobile: formData.mobile,
                status: formData.status?.value ?? formData.status,
                Id: formData.id,
            };

            if (mode === "Edit" && selectedRow?.id) {
                payload.id = selectedRow.id;
            }

            const res =
                mode === "Add"
                    ? await createPharmacyBoy(payload)
                    : await updatePharmacyBoy(payload);

            if (res?.data?.status === true) {
                toast.success(res.data.message);

                serverSideSearch(); // refresh table
                reset();
                setMode("Add");
                setIsOpen(false);
            }
            else if (res?.data?.status === "expired") {
                logout();
            }
            else {
                toast.error(res?.data?.message || "Operation failed");
            }

        } catch (err) {
            toast.error(err?.response?.data?.message || "Something went wrong");
        } finally {
            setFormLoading(false);
        }
    };




    const truncateByCharacters = (text = "", charLimit = 20) => {
        if (!text) return "";
        return text.length > charLimit
            ? text.slice(0, charLimit) + "..."
            : text;
    };

    return (
        <>
            <Head title="Users" />
            <Content>
                <BlockHead size="sm">
                    <BlockBetween>
                        <BlockHeadContent>
                            <BlockTitle page tag="h3">
                                Pharmacy Delivery Executive
                            </BlockTitle>
                        </BlockHeadContent>
                        {/* Admin not add user (manan sir) */}
                        <BlockHeadContent>
                            <Button
                                color="primary"
                                outline
                                className="me-n1"
                                onClick={() => {
                                    if (!isOpen) {
                                        setIsOpen(true);
                                        setMode("Add");
                                        reset();
                                    } else {
                                        setIsOpen(false);
                                    }
                                }}
                            >
                                <Icon name={isOpen ? "minus" : "plus"} />
                            </Button>
                        </BlockHeadContent>
                    </BlockBetween>
                </BlockHead>

                <Block>
                    {isOpen && (
                        <PreviewAltCard>
                            <Form onSubmit={handleSubmit(onFormSubmit)}>
                                <Row>
                                    <Col md="4">
                                        <MyInput
                                            register={register}
                                            watch={watch}
                                            setValue={setValue}
                                            trigger={trigger}
                                            errors={errors}
                                            title="Name"
                                            name="name"
                                            placeholder="Enter user name"
                                            required
                                            min={2}
                                            max={50}
                                            pattern={/^(?=.*[A-Za-z])[A-Za-z\s.'-]+$/}
                                            patternMsg="Name must contain letters and cannot be only spaces"
                                        />
                                    </Col>
                                    <Col md="4">
                                        <MyMobile
                                            register={register}
                                            watch={watch}
                                            setValue={setValue}
                                            trigger={trigger}
                                            errors={errors}
                                            title="Mobile"
                                            name="mobile"
                                            placeholder="Enter mobile number"
                                            required
                                            
                                        />
                                    </Col>
                                    <Col md="4">
                                        <MyEmail
                                            register={register}
                                            watch={watch}
                                            setValue={setValue}
                                            trigger={trigger}
                                            errors={errors}
                                            title="Email"
                                            name="email"
                                            placeholder="Enter email"
                                            required
                                        />
                                    </Col>
                                    <Col md="4">
                                        <Status
                                            title="Status"
                                            register={register}
                                            watch={watch}
                                            setValue={setValue}
                                            trigger={trigger}
                                            errors={errors}
                                            name="status"
                                        />
                                    </Col>
                                    {/* <Col md="3">
                    <MySelect
                      options={genderOption}
                      register={register}
                      watch={watch}
                      setValue={setValue}
                      trigger={trigger}
                      errors={errors}
                      title={"Gender"}
                      name={"gender"}
                      placeholder={"select gender"}
                      required
                    />
                  </Col> */}


                                    {/* <Col md="3">
                    <MyDate
                      register={register}
                      watch={watch}
                      setValue={setValue}
                      trigger={trigger}
                      errors={errors}
                      title="DOB"
                      name="dob"
                      placeholder="select dob"
                      // required
                    />
                  </Col> */}
                                    {/* <Col md="3" className={``}>
                    <MyInput
                      register={register}
                      watch={watch}
                      setValue={setValue}
                      trigger={trigger}
                      errors={errors}
                      title={"Full Address"}
                      name={"full_address"}
                      placeholder={"Enter full address"}
                      pattern={/^(?=.*[A-Za-z0-9])[A-Za-z0-9\s.,'#/\\-]+$/}
                      patternMsg="Address cannot be only spaces and contains invalid characters"
                      required
                      min={5}
                      max={200}
                      disabled={mode == "Approval"}
                    />
                  </Col> */}
                                    {/* <Col md="3" className={``}>
                    <MyInput
                      register={register}
                      watch={watch}
                      setValue={setValue}
                      trigger={trigger}
                      errors={errors}
                      title={"Pin Code"}
                      name={"pin_code"}
                      placeholder={"Enter pin code"}
                      required
                      min={6}
                      max={6}
                      pattern={/^[0-9]{6}$/}
                      patternMsg="Pin Code must be exactly 6 digits"
                      disabled={mode == "Approval"}
                    />
                  </Col> */}
                                    {/* <Col md="3" className={``}>
                    <MyInput
                      register={register}
                      watch={watch}
                      setValue={setValue}
                      trigger={trigger}
                      errors={errors}
                      title={"District"}
                      name={"district"}
                      placeholder={"Enter district"}
                      required
                      min={2}
                      max={100}
                      disabled={mode == "Approval"}
                    />
                  </Col> */}
                                    {/* <Col md="3" className={``}>
                    <MyInput
                      register={register}
                      watch={watch}
                      setValue={setValue}
                      trigger={trigger}
                      errors={errors}
                      title={"State"}
                      name={"state"}
                      placeholder={"Enter state"}
                      required
                      min={2}
                      max={100}
                      disabled={mode == "Approval"}
                    />
                  </Col> */}
                                    {/* <Col md="3">
                    <Status
                      register={register}
                      watch={watch}
                      title={"Status"}
                      setValue={setValue}
                      trigger={trigger}
                      errors={errors}
                    />
                  </Col>{" "} */}


                                    {/* <Col md="4">
                                  <ImageUpload
                                    getValues={getValues}
                                    design={4}
                                    id="user_image"
                                    watch={watch}
                                    trigger={trigger}
                                    setError={setError}
                                    clearErrors={clearErrors}
                                    label={"Profile Image"}
                                    errors={errors}
                                    register={register}
                                    image={"user_img"}
                                    image_url={"user_image"}
                                    setValue={setValue}
                                    handleImageOpenPreview={handleImageOpenPreview}
                                    required
                                    // validateDoc
                                    // approve={mode === "Approval" ? true : false}
                                    // size={2048}
                                  />
                                </Col> */}
                                    {/* <Col md="9">
                    <MyTextArea
                      register={register}
                      watch={watch}
                      setValue={setValue}
                      trigger={trigger}
                      errors={errors}
                      title="Description"
                      name="description"
                      placeholder="Enter user's bio"
                      min={50}
                      max={500}
                      cols={1}
                      row={1}
                    />
                  </Col>{" "} */}
                                </Row>     {" "}
                                <Col md="2">
                                    <MyButton isLoading={formLoading} mode={mode} />
                                </Col>
                            </Form>
                        </PreviewAltCard>
                    )}

                    <ApiPaginationDataTable
                        data={tableData}
                        columns={columns}
                        title="Pharmacy Delivery Executive"
                        isLoading={tableLoading}
                        register={register}
                        trigger={trigger}
                        watch={watch}
                        setValue={setValue}
                        errors={errors}
                        totalRows={totalRows}
                        perPage={perPage}
                        serverSearch
                        paginationServer
                        serverSideSearch={serverSideSearch}
                        handlePageChange={handlePageChange}
                        handlePerRowsChange={handlePerRowsChange} />
                </Block>
            </Content>

            <ConfirmModal
                isOpen={showModal}
                toggle={() => setShowModal(!showModal)}
                // onConfirm={confirmStatusChange}
                status={selectedRow?.status}
            />
        </>
    );
};

export default User;
